<div class="sh-collapsible-wrapper--vertical" [ngClass]="collapsed ? '--sh-collapsed' : ''">
    <div class="sh-collapsible">
        @if (contentVisible$ | async) {
            <ng-content></ng-content>
        }
    </div>
</div>
